import React from 'react';
import './Menu.css';

class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content_index:null,
            menuName:null
        };
    }

    redirectUrl(){
      const content_index = this.props.content_index ;
      this.props.setmenu(content_index);
    }


  render() {
    const {content_index} = this.state;
    const {menuName} = this.state;
    return (
        <button className="btnStyle" onClick={() => this.redirectUrl()} >
          {this.props.menuName}
        </button>
    );
  }
}
Menu.defaultProps = {
    menuName: 'Default Name',
    content_index: 'Default url',
    contentBody: 'Default contentBody'
};

export default Menu;
